// Modules
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { UserModule } from '../core/component/user/user.module';
import { Km2MConverterPipe } from './pipes/km2m-converter.pipe';
import { M2KmConverterPipe } from './pipes/m2km-converter.pipe';
import { PopupFieldPipe } from './pipes/popup-field.pipe';
import { EsriDatePipe } from './pipes/esri-date.pipe';
import { DetailViewTitlePipe } from './pipes/detail-view-title.pipe';
import { DomainPipe } from './pipes/domain.pipe';
import { FloatCalcFixDecimalPipe, FloatCalculatePipe } from './pipes/float-calculate.pipe';
import { AppMaterialModule } from './external/app-material.module';
import {CommonModule} from "@angular/common";
import {AppAgGridModule} from "./external/app-ag-grid.module";
import {EsriModule} from "../config/esri.module";
import {TranslateModule} from '@ngx-translate/core';
import {StartupErrorsComponent} from '../component/startup-errors/startup-errors.component';

export const COMPONENTS = [
  DomainPipe,
  EsriDatePipe,
  PopupFieldPipe,
  DetailViewTitlePipe,
  FloatCalculatePipe,
  FloatCalcFixDecimalPipe,
  M2KmConverterPipe,
  Km2MConverterPipe,
  StartupErrorsComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [UserModule, EsriModule, CommonModule, AppMaterialModule, AppAgGridModule, TranslateModule],
  exports: [
    DomainPipe,
    EsriDatePipe,
    PopupFieldPipe,
    DetailViewTitlePipe,
    FloatCalculatePipe,
    FloatCalcFixDecimalPipe,
    M2KmConverterPipe,
    Km2MConverterPipe,
    EsriModule,
    AppMaterialModule,
    AppAgGridModule,
    StartupErrorsComponent,
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
